import { Outlet } from 'react-router-dom';
import { Sidebar } from './Sidebar';
import { TopBar } from './TopBar';
import { useAppSelector, useAppDispatch } from '@/state/hooks';
import { setMobileMenuOpen } from '@/redux/slices/ui/uiSlice';
import { useAuth } from '@/contexts/AuthContext';

export function DashboardLayout() {
  const mobileMenuOpen = useAppSelector((s) => s.ui.mobileMenuOpen);
  const dispatch = useAppDispatch();
  const { user } = useAuth();

  return (
    <div className="flex h-screen overflow-hidden font-sans bg-surface-subtle">
      <Sidebar />

      {/* Mobile Sidebar Overlay */}
      {mobileMenuOpen && (
        <div
          className="fixed inset-0 bg-black/40 z-30 md:hidden transition-opacity"
          onClick={() => dispatch(setMobileMenuOpen(false))}
        />
      )}

      <div className="flex-1 flex flex-col min-w-0 min-h-0 overflow-hidden">
        <TopBar />
        <main key={user?.organizationId} className="flex-1 min-h-0 overflow-hidden">
          <Outlet />
        </main>
      </div>
    </div>
  );
}
